export function svgIcon(icon) {
  return getElement(icon).cloneNode(true)
}

export function svgIconStr(icon) {
  return getElement(icon).outerHTML
}

const elements = {}
function getElement(icon) {
  if (!elements[icon]) {
    const element = document.createElement("span")
    element.classList.add("svg-icon")
    element.innerHTML = `<svg><use xlink:href="${getSymbolDefsPath()}#icon-${icon}"></use></svg>`
    elements[icon] = element
  }
  return elements[icon]
}

let symbolDefsPath
function getSymbolDefsPath() {
  if (!symbolDefsPath) {
    symbolDefsPath = document.querySelector('meta[name="svg-symbol-defs"]').content
  }
  return symbolDefsPath
}
